import DataExportDataSetDropdownBase from './DataExportDataSetDropdownBase'

export default function BusinessDataTypeDropdown({value, onChange}){
    const options = ['All locations of a Client',
        'All locations with this Service',
        'All locations assigned to a Contact',
        'All training records for a Contact',
        'All info for a Client'];

    return(
        <DataExportDataSetDropdownBase options={options} value={value} onChange={onChange} />
    );
}